import { LocalstorageService } from './../../services/localstorage.service';
import { localeText } from './../../refacciones/models/localText.model';
import { GlobalServiceService } from './../../services/global-service.service';
import { Component, OnInit, Directive, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { Select2OptionData } from 'ng2-select2';
import { FiltersProvider } from '../filters';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import Swal from 'sweetalert2'
import * as moment from 'moment';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnInit {
  public showFilterStatus: boolean = true
  public showFilterZone: boolean = true
  public showFilterType: boolean = true
  public filtersForm: FormGroup;
  public personCheckedIndex = -1;
  profile: any
  usersCombo: any = []
  auxUsersCombo: any
  statesCombo: any
  clustersCombo: any
  statesComboRegion: any
  statesComboCedis: any
  statesCheckTypeMaintenaces: any
  statusManteince: any
  valueUser: any
  valueState: any
  valueCluster: any
  valueRegion: any
  valueCedis: any
  nameCluster: string
  nameState: string
  nameRegion: string
  nameCedis: string
  formGetValues: any
  formGetValuesCmb: any
  userData: any
  userValue: any
  valueMonth: any
  myControl = new FormControl();
  options: string[];
  filteredOptions: Observable<string[]>;

  anios: any

  months: any = [
    // { month: "TODOS", monthText: "Todos" },
    { month: "ENERO", monthText: "Enero" },
    { month: "FEBRERO", monthText: "Febrero" },
    { month: "MARZO", monthText: "Marzo" },
    { month: "ABRIL", monthText: "Abril" },
    { month: "MAYO", monthText: "Mayo" },
    { month: "JUNIO", monthText: "Junio" },
    { month: "JULIO", monthText: "Julio" },
    { month: "AGOSTO", monthText: "Agosto" },
    { month: "SEPTIEMBRE", monthText: "Septiembre" },
    { month: "OCTUBRE", monthText: "Octubre" },
    { month: "NOVIEMBRE", monthText: "Noviembre" },
    { month: "DICIEMBRE", monthText: "Diciembre" },
  ]


  monthsList: any = [
    // { month: "TODOS", monthText: "Todos" },
    { month: "ENERO", monthText: "Enero" },
    { month: "FEBRERO", monthText: "Febrero" },
    { month: "MARZO", monthText: "Marzo" },
    { month: "ABRIL", monthText: "Abril" },
    { month: "MAYO", monthText: "Mayo" },
    { month: "JUNIO", monthText: "Junio" },
    { month: "JULIO", monthText: "Julio" },
    { month: "AGOSTO", monthText: "Agosto" },
    { month: "SEPTIEMBRE", monthText: "Septiembre" },
    { month: "OCTUBRE", monthText: "Octubre" },
    { month: "NOVIEMBRE", monthText: "Noviembre" },
    { month: "DICIEMBRE", monthText: "Diciembre" },
  ]

  queryDate_start: string
  queryDate_end: string

  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  @Output() notifyParentInspect: EventEmitter<any> = new EventEmitter();
  @Output() notifyParentInspectDay: EventEmitter<any> = new EventEmitter();


  @Input("type") type: any
  @Input("from") from: any
  @Input("typeReport") typeReport: any

  //Mantenimientos
  queryMonth: string
  queryAnio: string

  //Banderas filtros
  public showFilterCluster: boolean = false
  public showFilterRegion: boolean = false
  public showFilterUnidadOperativa: boolean = false
  public showFilterDate: boolean = true
  //Data alamacenada
  filterManufactura = false
  filterDistribucion = false
  filterType: any;
  filterCluster: any;
  filterRegion: any;
  filterUnidadOperativa: any;
  //Cluster
  typeData = []
  clusters = []
  region = []
  operativa = []
  queryData
  //Banderas de los filtros
  clusterBandera
  regionBandera
  unidadOperativaBandera
  checkedDISTRIBUCION = false
  checkedMANUFACTURA = false
  //Bandera de carga
  cargaBandera

  //SWAL FLAG

  currentYear: Date;
  anio: any;

  selectedDay: any

  constructor(
    public filtersprovider: FiltersProvider,
    private fb: FormBuilder,
    private router: Router,
    private _global:LocalstorageService
  ) {
    this.getYears()
    this.currentYear = new Date();
    this.queryAnio = this.currentYear.getFullYear().toString()

    this.profile = JSON.parse(localStorage.getItem('userInfo'))
    this.userData = {
      user_id: this.profile.usuario_id,
    }
    this.filtersprovider.getClustersAll({ user_id: this.userData.user_id }).subscribe((res: any) => {
      if (res.data.length != 0)
        this.clustersCombo = (JSON.parse(JSON.stringify(res.data).replace(/name/g, "text").replace('[', '[{"id":"","text":""},')))
    })
    this.filtersprovider.getTypeMaintence().
      subscribe((resTypeMaintence: any) => {
        this.statesCheckTypeMaintenaces = resTypeMaintence.data;
      });
  }

  ngOnInit() {
    this.getYears()

    this.createForm();
    // this.viewUser()
    this.getFilterMaintenances()
  }

  getYears() {
    this.filtersprovider.getYears().subscribe((res: any) => {
      this.anios = res.data
    })
  }

  getFilterMaintenances() {
    this.filtersprovider.getFilterMaintenances(this.userData.user_id, this.queryData).subscribe((res: any) => {
      if (res.succes === true) {
        this.cargaBandera = true
        this.filterCluster = res.data.clusterName
        this.filterRegion = res.data.regionName
        this.filterUnidadOperativa = res.data.locationName
        Swal.close()
      }
    })
  }

  aplyFilterSection1(event) {


    if (this.checkedDISTRIBUCION !== true && event.source.id === 'DISTRIBUCION') {
      Swal({
        title: "Cargando filtros"
      })
      Swal.showLoading()
    }

    if (this.checkedMANUFACTURA !== true && event.source.id === 'MANUFACTURA') {
      Swal({
        title: "Cargando filtros"
      })
      Swal.showLoading()
    }

    this.cargaBandera = false
    this.queryData = null
    this.clusters = []
    this.region = []
    this.operativa = []
    // this.queryMonth= null

    this.showFilterRegion = false
    this.showFilterUnidadOperativa = false

    if (event.source.id === 'DISTRIBUCION') {
      this.checkedDISTRIBUCION = event.checked ? true : false
      if (this.checkedMANUFACTURA === false || this.checkedDISTRIBUCION === false) {
        this.loadchekmanufactura()
      }
    }
    if (event.source.id === 'MANUFACTURA') {
      this.checkedMANUFACTURA = event.checked ? true : false
      if (this.checkedMANUFACTURA === false || this.checkedDISTRIBUCION === false) {
        this.loadchekmanufactura()
      }
    }
    if (this.checkedMANUFACTURA === true && this.checkedDISTRIBUCION === true) {
      this.queryData = {
        "filters": {
          "type_site": ["DISTRIBUCION", "MANUFACTURA"]
        }
      }
      this.getFilterMaintenances()
    } else {
      if (this.checkedDISTRIBUCION === true && event.source.id === 'DISTRIBUCION') {
        this.queryData = {
          "filters": {
            "type_site": ["DISTRIBUCION"]
          }
        }
        this.getFilterMaintenances()
      }

      if (this.checkedMANUFACTURA === true && event.source.id === 'MANUFACTURA') {
        this.queryData = {
          "filters": {
            "type_site": ["MANUFACTURA"]
          }
        }
        this.getFilterMaintenances()
      }
    }
  }

  aplyFilterSection1Reportes(event) {

    if (this.checkedDISTRIBUCION !== true && event.source.id === 'DISTRIBUCION') {
      Swal({
        title: "Cargando filtros"
      })
      Swal.showLoading()
    }

    if (this.checkedMANUFACTURA !== true && event.source.id === 'MANUFACTURA') {
      Swal({
        title: "Cargando filtros"
      })
      Swal.showLoading()
    }

    this.cargaBandera = false
    this.queryData = null
    this.clusters = []
    this.region = []
    this.operativa = []
    // this.queryMonth= null

    this.showFilterRegion = false
    this.showFilterUnidadOperativa = false

    if (event.source.id === 'DISTRIBUCION1') {
      this.checkedDISTRIBUCION = event.checked ? true : false
      if (this.checkedMANUFACTURA === false || this.checkedDISTRIBUCION === false) {
        this.loadchekmanufactura()
      }
    }
    if (event.source.id === 'MANUFACTURA1') {
      this.checkedMANUFACTURA = event.checked ? true : false
      if (this.checkedMANUFACTURA === false || this.checkedDISTRIBUCION === false) {
        this.loadchekmanufactura()
      }
    }
    if (this.checkedMANUFACTURA === true && this.checkedDISTRIBUCION === true) {
      this.queryData = {
        "filters": {
          "type_site": ["DISTRIBUCION", "MANUFACTURA"]
        }
      }
      this.getFilterMaintenances()
    } else {
      if (this.checkedDISTRIBUCION === true && event.source.id === 'DISTRIBUCION1') {
        this.queryData = {
          "filters": {
            "type_site": ["DISTRIBUCION"]
          }
        }
        this.getFilterMaintenances()
      }

      if (this.checkedMANUFACTURA === true && event.source.id === 'MANUFACTURA1') {
        this.queryData = {
          "filters": {
            "type_site": ["MANUFACTURA"]
          }
        }
        this.getFilterMaintenances()
      }
    }
  }

  loadchekmanufactura() {

    if (this.checkedDISTRIBUCION === true) {
      this.queryData = {
        "filters": {
          "type_site": ["DISTRIBUCION"]
        }
      }
      this.getFilterMaintenances()
    }

    if (this.checkedMANUFACTURA === true) {
      this.queryData = {
        "filters": {
          "type_site": ["MANUFACTURA"]
        }
      }
      this.getFilterMaintenances()
    }
  }

  filter(data) {
    if (data === 1) {
      Swal({
        title: "Cargando filtros"
      })
      Swal.showLoading()
      this.getFilterMaintenances()
      this.showFilterRegion = true
    }
    if (data === 2) {
      Swal({
        title: "Cargando filtros"
      })
      Swal.showLoading()
      this.getFilterMaintenances()
      this.showFilterUnidadOperativa = true
    }
  }

  aplyFilterSection2(data) {

    this.clusters = []
    this.region = []
    this.showFilterRegion = false
    data.forEach(async element => {
      this.clusters.push(element.name)
    });
    this.queryData.filters.clusterName = this.clusters
  }
  aplyFilterSection3(data) {

    this.region = []
    this.operativa = []
    this.showFilterUnidadOperativa = false
    data.forEach(async element => {
      this.region.push(element.name)
    });
    this.queryData.filters.regionName = this.region
  }

  aplyFilterSection4(data) {
    this.operativa = []
    data.forEach(async element => {
      this.operativa.push(element.name)
    });
    this.queryData.filters.locationName = this.operativa
  }

  aplyFilterSection5(data) {
    this.queryMonth = null
    this.queryMonth = data
  }
  aplyFilterSection6(data) {
    this.queryAnio = null
    this.queryAnio = data
  }
  // viewUser() {
  //   this.filtersprovider.getUsers(this.userData.user_id).subscribe((resUser: any) => {
  //     if (resUser.status) {
  //       this.usersCombo = [{ id: '', text: '' }]
  //       this.auxUsersCombo = resUser.data.map(item => {
  //         return { id: item.user_id, text: item.nombre }
  //       })
  //       this.usersCombo = this.usersCombo.concat(this.auxUsersCombo)
  //       this.options = this.auxUsersCombo.map(function (value) {
  //         return value.text;
  //       });
  //       this.filteredOptions = this.myControl.valueChanges
  //         .pipe(
  //           startWith(''),
  //           map(value => this._filter(value))
  //         );
  //     }
  //   })
  // }

  // private _filter(value: string): string[] {
  //   const filterValue = value.toLowerCase();
  //   return this.options.filter(option => option.toLowerCase().includes(filterValue));
  // }

  sendNotification(filters) {
    if (this.typeReport == 'inspect') {
      console.log(filters);

      this.notifyParentInspect.emit(filters);

    } else {

      this.notifyParent.emit(filters);
    }
  }

  createForm() {
    this.filtersForm = this.fb.group({
      sinorden: new FormControl,
      conorden: new FormControl,
      consolped: new FormControl,
      enproceso: new FormControl,
      cerrado: new FormControl,
      aceptado: new FormControl,
      pendiente: new FormControl,
      cmbState: new FormControl,
      cmbCluster: new FormControl,
      cmbRegion: new FormControl,
      cmbCedis: new FormControl,
      chkFijo: new FormControl,
      chkProgramado: new FormControl,
      chkCorrectivo: new FormControl,
      chkPreventivo: new FormControl,
      date_start: new FormControl,
      date_end: new FormControl,
      enero: new FormControl,
      febrero: new FormControl,
      marzo: new FormControl,
      abril: new FormControl,
      mayo: new FormControl,
      junio: new FormControl,
      julio: new FormControl,
      agosto: new FormControl,
      septiembre: new FormControl,
      octubre: new FormControl,
      noviembre: new FormControl,
      diciembre: new FormControl,
    })


    /*Values Defaults*/

    this.filtersForm.setValue({
      sinorden: false,
      conorden: false,
      consolped: false,
      enproceso: false,
      cerrado: false,
      aceptado: false,
      pendiente: false,
      cmbState: false,
      cmbCluster: false,
      cmbRegion: false,
      cmbCedis: false,
      chkFijo: false,
      chkProgramado: false,
      chkCorrectivo: false,
      chkPreventivo: false,
      date_start: false,
      date_end: false,
      enero: false,
      febrero: false,
      marzo: false,
      abril: false,
      mayo: false,
      junio: false,
      julio: false,
      agosto: false,
      septiembre: false,
      octubre: false,
      noviembre: false,
      diciembre: false
    })
    this.valueCluster = ''
    //this.valueState = ''
    this.valueRegion = ''
    this.valueCedis = ''


  }

  clickFiltersApply() {
    this.parseDateForm();
  }

  changeComboUser(e) {
    for (var i = 0; i < this.usersCombo.length; i++) {
      if (e === this.usersCombo[i].text) {
        this.userValue = i.toString()
      }
    }
  }


  changeComboCluster(e) {
    this.valueCluster = e.id

    this.filtersprovider.getRegionsAll({ user_id: this.userData.user_id, cluster: JSON.stringify(e.id) }).
      subscribe((resRegion: any) => {
        this.statesComboRegion = (JSON.parse(JSON.stringify(resRegion.data).replace(/name/g, "text").replace('[', '[{"id":"","text":""},')))
      });
    this.nameCluster = e.text
  }

  /* changeComboState(e) {
    this.valueState = e.id;

    this.filtersprovider.getInfoFiltersRegion({ user_id : this.userData.user_id , state : e.id  }).
      subscribe((resRegion:any) => {
        this.statesComboRegion = (JSON.parse(JSON.stringify(resRegion.data).replace(/name/g,"text").replace('[','[{"id":"","text":""},')))
      });
    this.nameState= e.text

  } */

  changeComboRegion(e) {
    this.valueRegion = e.id;
    this.filtersprovider.getLocationsAll({ user_id: this.userData.user_id, region: JSON.stringify(e.id) }).
      subscribe((resCedis: any) => {
        this.statesComboCedis = (JSON.parse(JSON.stringify(resCedis.data).replace(/name/g, "text").replace('[', '[{"id":"","text":""},')))
      });
    this.nameRegion = e.text
  }

  changeComboCedis(e) {
    this.valueCedis = e.id;
    this.nameCedis = e.text
  }

  changetypeMainteince(e, index: number) {
    this.personCheckedIndex = e.checked ? index : -1;
  }

  changetypeStatus(e) {

  }

  changeMonth(e) {

  }

  parseDateForm() {

    this.formGetValues = {};
    this.statusManteince = [];
    this.valueMonth = []
    this.formGetValuesCmb = {};
    this.formGetValuesCmb = {
      cluster: parseInt(this.valueCluster),
      clusterName: this.nameCluster,
      /* state  : parseInt(this.valueState) ,
      stateName: this.nameState, */
      region: parseInt(this.valueRegion),
      regionName: this.nameRegion,
      location: parseInt(this.valueCedis),
      locationName: this.nameCedis
    };

    this.formGetValues = Object.assign(this.filtersForm.getRawValue(), this.formGetValuesCmb)

    for (var i in this.formGetValues) {
      if (!this.formGetValues[i]) {
        delete this.formGetValues[i]
      } else {
        switch (i) {
          case 'sinorden':
            delete this.formGetValues[i]
            this.statusManteince.push(3)
            break;
          case 'conorden':
            delete this.formGetValues[i]
            this.statusManteince.push(2)
            break;
          case 'consolped':
            delete this.formGetValues[i]
            this.statusManteince.push(8)
            break;
          case 'enproceso':
            delete this.formGetValues[i]
            this.statusManteince.push(4)
            break;
          case 'cerrado':
            delete this.formGetValues[i]
            this.statusManteince.push(5)
            break;
          case 'aceptado':
            delete this.formGetValues[i]
            this.statusManteince.push(11)
            break;
          case 'pendiente':
            delete this.formGetValues[i]
            this.statusManteince.push(7)
            break;

        }
        switch (i) {

          case 'chkFijo':
            delete this.formGetValues[i]
            this.formGetValues = Object.assign(this.formGetValues, { 'maintenance_type': 2 })
            break;
          case 'chkProgramado':
            delete this.formGetValues[i]
            this.formGetValues = Object.assign(this.formGetValues, { 'maintenance_type': 3 })
            break;
          case 'chkCorrectivo':
            delete this.formGetValues[i]
            this.formGetValues = Object.assign(this.formGetValues, { 'maintenance_type': 4 })
            break;
          case 'chkPreventivo':
            delete this.formGetValues[i]
            this.formGetValues = Object.assign(this.formGetValues, { 'maintenance_type': 5 })
            break;
        }
        switch (i) {
          case 'enero':
            delete this.formGetValues[i]
            this.valueMonth.push(1)
            break;
          case 'febrero':
            delete this.formGetValues[i]
            this.valueMonth.push(2)
            break;
          case 'marzo':
            delete this.formGetValues[i]
            this.valueMonth.push(3)
            break;
          case 'abril':
            delete this.formGetValues[i]
            this.valueMonth.push(4)
            break;
          case 'mayo':
            delete this.formGetValues[i]
            this.valueMonth.push(5)
            break;
          case 'junio':
            delete this.formGetValues[i]
            this.valueMonth.push(6)
            break;
          case 'julio':
            delete this.formGetValues[i]
            this.valueMonth.push(7)
            break;
          case 'agosto':
            delete this.formGetValues[i]
            this.valueMonth.push(8)
            break;
          case 'septiembre':
            delete this.formGetValues[i]
            this.valueMonth.push(9)
            break;
          case 'octubre':
            delete this.formGetValues[i]
            this.valueMonth.push(10)
            break;
          case 'noviembre':
            delete this.formGetValues[i]
            this.valueMonth.push(11)
            break;
          case 'diciembre':
            delete this.formGetValues[i]
            this.valueMonth.push(12)
            break;

        }
        let dateFormat
        switch (i) {

          case 'date_start':
            dateFormat = new Date(this.formGetValues['date_start']);
            this.formGetValues['date_start'] = (dateFormat.getFullYear()) + "-" + dateFormat.getMonth() + "-" + dateFormat.getDate()
            break;

          case 'date_end':
            dateFormat = new Date(this.formGetValues['date_end']);
            this.formGetValues['date_end'] = (dateFormat.getFullYear()) + "-" + dateFormat.getMonth() + "-" + dateFormat.getDate()
            break;
        }
      }
    }

    if (this.statusManteince.length > 0) {
      this.formGetValues = Object.assign(this.formGetValues, { 'status': this.statusManteince })
    }
    if (this.valueMonth.length > 0) {
      this.formGetValues = Object.assign(this.formGetValues, { 'month_list': this.valueMonth })
    }
    if (this.userValue != undefined && this.userValue != "") {
      this.formGetValues = Object.assign(this.formGetValues, { 'user_creation_id': this.userValue })
    }

    // Filtros por mes para mantenimientos
    if (this.queryMonth) {
      this.formGetValues = Object.assign(this.formGetValues, { 'mes_ejecutado': this.queryMonth })
    }
    if (this.queryAnio) {

      this.formGetValues = Object.assign(this.formGetValues, { 'anio': this.queryAnio })
    }
    // Filtros por fecha para reportes
    // if (this.queryDate_start && this.queryDate_end) {
    //   this.formGetValues = Object.assign(
    //     this.formGetValues, {
    //     "date_start": this.convertDate(this.queryDate_start),
    //     "date_end": this.convertDate(this.queryDate_end)
    //   })
    // } else if (this.queryDate_start && !this.queryDate_end) {
    //   this.formGetValues = Object.assign(
    //     this.formGetValues, {
    //     "date_start": this.convertDate(this.queryDate_start),
    //     "date_end": this.convertDate(this.queryDate_start)
    //   })
    // } else if (!this.queryDate_start && this.queryDate_end) {
    //   this.formGetValues = Object.assign(
    //     this.formGetValues, {
    //     "date_start": this.convertDate(this.queryDate_end),
    //     "date_end": this.convertDate(this.queryDate_end)
    //   })
    // } else if (!this.queryDate_start && !this.queryDate_end) {
    //   this.formGetValues = Object.assign(
    //     this.formGetValues, {
    //     "date_start": "",
    //     "date_end": ""
    //   })
    // }

    if (this.from === "mantenimientos") {

    }

    if (this.from === "reportes") {

    }

    if (this.isEmpty(this.formGetValues)) {
      this.sendNotification(null)
    } else {


      if (this.clusters.length === 0 && this.region.length === 0 && this.operativa.length === 0 && this.checkedDISTRIBUCION === false && this.checkedMANUFACTURA === false) {
        if (this.formGetValues.date_start === '' && this.formGetValues.date_end === '' && !this.formGetValues.mes_ejecutado) {

          this.sendNotification(this.formGetValues)
        } else {

          this.sendNotification(this.formGetValues)
        }
      } else {
        this.queryData.filters.anio = this.queryAnio

        if (this.operativa.length === 0) {
          this.queryData.filters.locationName = undefined
        }
        if (this.region.length === 0) {
          this.queryData.filters.regionName = undefined
        }
        if (this.clusters.length === 0) {
          this.queryData.filters.clusterName = undefined
        }
        this.queryData.filters.mes_ejecutado = this.queryMonth
        this.sendNotification(this.queryData)

      }
    }
  }

  convertDate = (date) => {
    date = new Date(date)
    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()} 00:00:00`
  }

  isEmpty(obj) {
    // null and undefined are "empty"
    if (obj == null) return true;
    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;
    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;
    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  cleanFrom() {

    this.queryAnio = this.currentYear.getFullYear().toString()
    this.cargaBandera = false
    this.queryData = null
    this.clusters = []
    this.region = []
    this.operativa = []
    this.queryMonth = undefined
    this.filterManufactura = null
    this.filterDistribucion = null
    this.showFilterRegion = false
    this.showFilterUnidadOperativa = false
    this.checkedDISTRIBUCION = false
    this.checkedMANUFACTURA = false
    this.createForm()
    this.sendNotification(null)
  }

  cleanFrom2() {

    this.queryAnio = this.currentYear.getFullYear().toString()
    this.cargaBandera = false
    this.queryData = null
    this.clusters = []
    this.region = []
    this.operativa = []
    this.queryMonth = undefined
    this.filterManufactura = null
    this.filterDistribucion = null
    this.showFilterRegion = false
    this.showFilterUnidadOperativa = false
    this.checkedDISTRIBUCION = false
    this.checkedMANUFACTURA = false
    this.createForm()
    this.sendNotification(null)

  }


  cleanCalendar(){
    this.selectedDay = null;
    // this.queryAnio = this.currentYear.getFullYear().toString()
    this.cargaBandera = false
    this.queryData = null
    this.clusters = []
    this.region = []
    this.operativa = []
    this.queryMonth = undefined
    this.filterManufactura = null
    this.filterDistribucion = null
    this.showFilterRegion = false
    this.showFilterUnidadOperativa = false
    this.checkedDISTRIBUCION = false
    this.checkedMANUFACTURA = false
    this._global.emitNavChangeEvent(true);
    // this.createForm()
    this.sendNotification(null)
  }


  // calendario
  dayChange(day) {
    if (this.typeReport == 'inspect') {
      this.selectedDay = day.selectedDate.day
      const data = {
        fecha_inicio: moment(day.selectedDate.day).format("YYYY-MM-DD"),
        fecha_fin: moment(day.selectedDate.day).format("YYYY-MM-DD")
      }
      this.notifyParentInspectDay.emit(data);
      // this.sendNotification(data)

    }
    if (this.typeReport == 'report') {
      // this.selectedDay = day.selectedDate.day
    }
  }
}
